import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faWhatsapp,
    faInstagram,
    faAirbnb
} from "@fortawesome/free-brands-svg-icons";
import {
    faStar,
    faLocationDot,
    faTree,
    faWater,
    faWineGlass,
    faVolleyballBall,
    faCircleQuestion,
    faGift,
    faCoffee,
    faCrown
} from "@fortawesome/free-solid-svg-icons";

import sliderImages from "../assets/index.js";
import "../styles/landingPage.css";

const LandingPage = () => {
    const airbnbLink = "https://www.airbnb.com.br/rooms/1417344118548404720?source_impression_id=p3_1764869420_P3UoS6dK1s0tJFOG";
    const whatsappNumber = "5542999332999";
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=Olá! Vi o site da Pousada e gostaria de verificar disponibilidade.`;
    const instagramLink = "https://instagram.com/chaleschacaradospinheiros/";

    const reviews = [
        {
            text: "Bem fácil de achar o local, os anfitriões são super receptivos e nos deixaram bem a vontade, chegamos e encontramos o chalé extremamente limpo, com o ar e a hidromassagem já ligados. Com certeza voltaremos mais vezes! A chácara é linda, dá para pescar e descansar tranquilo nas redes.",
            author: "William",
            platform: "Airbnb"
        },
        {
            text: "O lugar é maravilhoso, muito lindo, cada detalhe para a gente se sentir em casa, tem muita natureza, um lago lindo de frente para o chalé, é muito gostoso dentro do chalé, a cama é maravilhosa, tudo é confortável, os proprietários são muito simpáticos e deram toda assistência, a experiência realmente é inesquecível, bem romântico 🥰",
            author: "Luciane Oliveira",
            platform: "Google"
        },
        {
            text: "Ótimo atendimento; café da manhã incrível. Conforto da roupa de cama, das toalhas e da banheira de hidromassagem, com regulação eletrônica de temperatura.",
            author: "Rodrigo",
            platform: "Booking.com"
        }
    ];

    return (
        <div className="lp-container">

            <header className="lp-hero">
                <Swiper
                    modules={[Autoplay, EffectFade]}
                    effect="fade"
                    loop={true}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    className="lp-hero-bg"
                >
                    {sliderImages.map((img, index) => (
                        <SwiperSlide key={index}>
                            <div
                                className="lp-hero-image"
                                style={{ backgroundImage: `url(${img})` }}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="lp-overlay">
                    <div className="lp-hero-content">
                        <p className="lp-subtitle">IMBITUVA - PARANÁ</p>
                        <h1>Pousada Chácara dos Pinheiros</h1>
                        <p className="lp-tagline">
                            Tranquilidade, aconchego e conexão com a natureza.
                        </p>

                        <div className="lp-buttons">
                            <a href={whatsappLink} target="_blank" rel="noreferrer" className="btn-primary">
                                <FontAwesomeIcon icon={faWhatsapp} /> Reservar agora
                            </a>
                        </div>
                    </div>
                </div>
            </header>

            <section className="lp-section lp-about-light">
                <div className="lp-content">
                    <h2>Refúgio no Campo</h2>
                    <p>
                        Seja bem-vindo! Descubra um espaço planejado para proporcionar uma
                        experiência memorável, a apenas 10km do centro de Imbituva e a 500 metros da BR-373.
                    </p>

                    <div className="lp-features">
                        <div className="feat-item">
                            <FontAwesomeIcon icon={faTree} className="feat-icon" />
                            <h3>Natureza</h3>
                            <p></p>
                        </div>
                        <div className="feat-item">
                            <FontAwesomeIcon icon={faWater} className="feat-icon" />
                            <h3>Lago, Pesca e Piscina</h3>
                            <p></p>
                        </div>
                        <div className="feat-item">
                            <FontAwesomeIcon icon={faVolleyballBall} className="feat-icon" />
                            <h3>Lazer Completo</h3>
                            <p>Quadra de Areia, Redário & Balanço</p>
                        </div>
                        <div className="feat-item">
                            <FontAwesomeIcon icon={faWineGlass} className="feat-icon" />
                            <h3>Conforto</h3>
                            <p>Chalés Aconchegantes com Hidro e Lareira</p>
                        </div>
                        <div className="feat-item">
                            <FontAwesomeIcon icon={faCrown} className="feat-icon" />
                            <h3>Exclusividade</h3>
                            <p>Poucas pessoas, muita conexão</p>
                        </div>
                        <div className="feat-item">
                            <FontAwesomeIcon icon={faCoffee} className="feat-icon" />
                            <h3>Café da Manhã</h3>
                            <p>Servido diretamente no seu chalé, com itens frescos e saborosos</p>
                        </div>
                        <div className="feat-item">
                            <FontAwesomeIcon icon={faGift} className="feat-icon" />
                            <h3>Serviços Personalizados</h3>
                            <p>Decorações românticas e serviços personalizados para tornar sua estadia inesquecível</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="lp-section lp-location">
                <div className="lp-content">
                    <h2>Localização Privilegiada</h2>
                    <p>
                        O equilíbrio perfeito entre o sossego do campo e a facilidade de acesso. 
                        Chegar até nós é fácil, seguro e sem complicações.
                    </p>
                    
                    <div className="lp-location-cards">
                        <div className="location-card">
                            <FontAwesomeIcon icon={faLocationDot} className="location-icon" />
                            <h4>Acesso Super Fácil</h4>
                            <p>Estamos a apenas <strong>500 metros da BR-373</strong> (rodovia principal). Acesso prático para qualquer tipo de veículo, sem longas estradas de terra.</p>
                        </div>
                        <div className="location-card">
                            <FontAwesomeIcon icon={faTree} className="location-icon" />
                            <h4>Perto, mas reservado</h4>
                            <p>A apenas <strong>10km do centro de Imbituva</strong>. Você fica perto o suficiente para qualquer conveniência, e longe o suficiente para ter total tranquilidade.</p>
                        </div>
                    </div>
                    <div className="lp-map-container">
                        <iframe 
                            src="https://maps.google.com/maps?q=Pousada+Chal%C3%A9s+Ch%C3%A1cara+dos+Pinheiros+Imbituva&t=&z=15&ie=UTF8&iwloc=&output=embed" 
                            width="100%" 
                            height="450" 
                            style={{ border: 0 }} 
                            allowFullScreen="" 
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Mapa de Localização da Pousada Chácara dos Pinheiros"
                        ></iframe>
                    </div>
                </div>
            </section>

            <section className="lp-gallery-section">
                <div className="lp-gallery-grid">
                    <div className="gallery-item large" style={{ backgroundImage: `url(${sliderImages[1]})` }}></div>
                    <div className="gallery-item" style={{ backgroundImage: `url(${sliderImages[5]})` }}></div>
                    <div className="gallery-item" style={{ backgroundImage: `url(${sliderImages[6] || sliderImages[2]})` }}></div>
                    <div className="gallery-item" style={{ backgroundImage: `url(${sliderImages[8]})` }}></div>
                    <div className="gallery-item" style={{ backgroundImage: `url(${sliderImages[0]})` }}></div>
                </div>
            </section>

            <section className="lp-section lp-reviews-light">
                <h3>Experiências Reais</h3>
                <div className="lp-reviews-grid">
                    {reviews.map((rev, i) => (
                        <div key={i} className="review-card-light">
                            <div className="stars">
                                {[...Array(5)].map((_, n) => <FontAwesomeIcon key={n} icon={faStar} />)}
                            </div>
                            <p>"{rev.text}"</p>
                            <span>— {rev.author}, via {rev.platform}</span>
                        </div>
                    ))}
                </div>
            </section>

            <section className="lp-section lp-faq-section">
                <div className="lp-content-wrapper">
                    <h3><FontAwesomeIcon icon={faCircleQuestion} /> Dúvidas Frequentes</h3>

                    <div className="lp-faq-grid">
                        <div className="faq-item">
                            <h4>O que está incluso nos chalés?</h4>
                            <p>Banheira de hidromassagem dupla, Lareira, Ar-condicionado (quente/frio), Cama King Size, Cozinha completa, Wi-Fi e Smart TV. Roupas de camas, banho, amenities de banho e roupão inclusos.</p>
                        </div>

                        <div className="faq-item">
                            <h4>Possui alimentação/restaurante?</h4>
                            <p>Servimos uma cesta de café da manhã (cortesia) entregue no chalé. Não temos restaurante, mas nossos chalés possuem cozinha completa, onde você pode preparar suas próprias refeições, ou é possível pedir delivery com restaurantes das proximidades.</p>
                        </div>

                        <div className="faq-item">
                            <h4>Quais as opções de lazer?</h4>
                            <p>Além do descanso, temos 4 lagos para pesca esportiva, quiosque com mesa de bilhar, quadra de areia, redários, balanço, piscina e uma trilha de acesso ao Rio Imbituvinha.</p>
                        </div>

                        <div className="faq-item">
                            <h4>Há estacionamento gratuito para hóspedes?</h4>
                            <p>Sim, o estacionamento é gratuito, interno e exclusivo para hóspedes.</p>
                        </div>

                        <div className="faq-item">
                            <h4>O café da manhã está incluso na diária?</h4>
                            <p>Sim, entregamos uma cesta de café da manhã no conforto do seu chalé no horário escolhido.</p>
                        </div>

                    </div>
                </div>
            </section>
            <footer className="lp-footer">
                <div className="lp-footer-content">
                    <div className="lp-address">
                        <FontAwesomeIcon icon={faLocationDot} className="footer-icon" />
                        <p>
                            Estrada do Colono, Mato Branco de Baixo<br />
                            Imbituva - PR
                        </p>
                    </div>
                    <div className="lp-contact-footer">
                        <p>+55 42 9 9933-2999 (Graciele)</p>
                        <p>+55 42 9 9129-4333 (Junior)</p>
                    </div>
                    <div className="lp-copy">
                        © 2025 Pousada Chácara dos Pinheiros
                    </div>
                </div>
            </footer>

            <a href={whatsappLink} target="_blank" rel="noreferrer" className="whatsapp-float">
                <FontAwesomeIcon icon={faWhatsapp} />
            </a>

        </div>
    );
};

export default LandingPage;